"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardsComposer = _interopRequireDefault(require("./adaptiveCards/AdaptiveCardsComposer"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _useComposerProps = _interopRequireDefault(require("./useComposerProps"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Composer = _botframeworkWebchatComponent.Components.Composer;

var FullComposer = function FullComposer(props) {
  var adaptiveCardsHostConfig = props.adaptiveCardsHostConfig,
      adaptiveCardsPackage = props.adaptiveCardsPackage,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["adaptiveCardsHostConfig", "adaptiveCardsPackage", "children"]);
  var composerProps = (0, _useComposerProps.default)(props);
  return _react.default.createElement(_AdaptiveCardsComposer.default, {
    adaptiveCardsHostConfig: adaptiveCardsHostConfig,
    adaptiveCardsPackage: adaptiveCardsPackage
  }, _react.default.createElement(Composer, (0, _extends2.default)({}, otherProps, composerProps), children));
};

FullComposer.defaultProps = _objectSpread({}, Composer.defaultProps, {
  adaptiveCardsHostConfig: undefined,
  adaptiveCardsPackage: undefined,
  children: undefined
});
FullComposer.propTypes = _objectSpread({}, Composer.propTypes, {
  adaptiveCardsHostConfig: _propTypes.default.any,
  adaptiveCardsPackage: _propTypes.default.any,
  children: _propTypes.default.any
});
var _default = FullComposer;
exports.default = _default;